import { SeasonModel } from '@modules/season/season-model';

const { fields } = SeasonModel;

export default [
  fields.id,
  fields.name,
  fields.createdAt,
  fields.updatedAt
];
